module.exports = __webpack_public_path__ + "static/4-b180fac9f6da7d24b26a0b49c219aabc.jpeg";